// Opt-in de mutation (e, desde o #1172, de query em polling) pra dispensar o
// toast global de erro (`queryClient.ts`).
//
// O padrão do painel é sinalizar duas vezes (toast + o que a tela mostrar).
// Isso vale pra quem não trata o erro, mas num formulário que já marca o campo
// ("IMEI já cadastrado") o toast genérico ao lado ("Erro 409 / duplicate_imei")
// só repete o mesmo fato em código cru. O mesmo vale pra quem já mostra um
// toast próprio com o código traduzido. Quem usa este meta PRECISA exibir o
// erro na própria tela: sem isso, a falha some sem aviso nenhum.
//
// O breadcrumb continua sendo registrado em qualquer caso: o que sai é só o
// aviso visual, não a observabilidade.

/// `useMutation({ meta: INLINE_ERROR_META, onError: ... })`, ou
/// `useQuery({ meta: INLINE_ERROR_META })` com o `isError` desenhado na tela.
export const INLINE_ERROR_META = { inlineError: true } as const;

/// O handler global deve mostrar toast pra esta mutation?
export function showsGlobalErrorToast(meta: Record<string, unknown> | undefined): boolean {
  return meta?.inlineError !== true;
}
